import React, { useState, Dispatch, SetStateAction } from "react";
import {
  Modal,
  Button,
  Select,
  MenuItem,
  Checkbox,
  TextField,
  SelectChangeEvent,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import EditText from "../components/editText";

interface AddNotificationModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const AddNotification: React.FC<AddNotificationModalProps> = ({
  open,
  onClose,
  setOpen,
}) => {
  const [userName, setUserName] = useState("");

  const [formvalue, setFormvalue] = useState({
    selectField1: "0",
    type: "0",
    selectedRoles: [] as string[],
  });

  const handleSingleSelectChange = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    setFormvalue((prev) => ({
      ...prev,
      [name]: value,
      selectedRoles: [], // reset selected roles on group change
    }));
  };
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedOffer, setSelectedOffer] = useState("");

  const categoryOptions = ["Category A", "Category B", "Category C"];
  const offerOptions = ["Offer 1", "Offer 2", "Offer 3"];
  const handleMultiSelectChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value },
    } = event;

    const currentOptions = roleOptionsMap[formvalue.selectField1] || [];
    const allValues = currentOptions.map((r) => r.value);

    if (value.includes("all")) {
      const allSelected = formvalue.selectedRoles.length === allValues.length;
      setFormvalue((prev) => ({
        ...prev,
        selectedRoles: allSelected ? [] : allValues,
      }));
    } else {
      setFormvalue((prev) => ({
        ...prev,
        selectedRoles: typeof value === "string" ? value.split(",") : value,
      }));
    }
  };

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const roleOptionsMap: { [key: string]: { label: string; value: string }[] } =
    {
      "10": [
        { label: "User 1", value: "u1" },
        { label: "User 2", value: "u2" },
        { label: "User 3", value: "u3" },
      ],
      "20": [
        { label: "Employee 1", value: "e1" },
        { label: "Employee 2", value: "e2" },
        { label: "Employee 3", value: "e3" },
      ],
      "30": [
        { label: "Sub Admin 1", value: "s1" },
        { label: "Sub Admin 2", value: "s2" },
      ],
      "40": [
        { label: "Android User 1", value: "a1" },
        { label: "Android User 2", value: "a2" },
      ],
      "50": [
        { label: "iOS User 1", value: "i1" },
        { label: "iOS User 2", value: "i2" },
      ],
      "60": [
        { label: "Group 1", value: "i1" },
        { label: "Group 2", value: "i2" },
      ],
    };
  const getRolePlaceholder = () => {
    switch (formvalue.selectField1) {
      case "10":
        return "Select User";
      case "20":
        return "Select Employee";
      case "30":
        return "Select Sub-Admin";
      case "40":
        return "Select Android User";
      case "50":
        return "Select iOS User";
      case "60":
        return "Select Groups";
      default:
        return "Select Role";
    }
  };
  const currentOptions = roleOptionsMap[formvalue.selectField1] || [];
  const [legal3, setLegal3] = useState<string>("");

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="modal addNotification_modal"
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Notification</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>

          <form className="form">
            <div className="gap_p">
              <div className="control_group w_100">
                <TextField
                  variant="outlined"
                  placeholder="Notification Title"
                  fullWidth
                  hiddenLabel
                />
              </div>

              <div className="control_group w_50">
                <Select
                  fullWidth
                  name="selectField1"
                  value={formvalue.selectField1}
                  onChange={handleSingleSelectChange}
                >
                  <MenuItem disabled value="0">
                    Select Send To
                  </MenuItem>
                  <MenuItem value="10">User</MenuItem>
                  <MenuItem value="20">Employee</MenuItem>
                  <MenuItem value="30">Sub-Admin</MenuItem>
                  <MenuItem value="40">Android User</MenuItem>
                  <MenuItem value="50">IOS User</MenuItem>
                  <MenuItem value="60">Groups</MenuItem>
                  <MenuItem value="70">All</MenuItem>
                </Select>
              </div>

              {/* Conditional Multi-Select */}
              {formvalue.selectField1 !== "0" && (
                <div className="control_group w_50">
                  <Select
                    fullWidth
                    multiple
                    displayEmpty
                    name="selectedRoles"
                    value={formvalue.selectedRoles}
                    onChange={handleMultiSelectChange}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <span>{getRolePlaceholder()}</span>;
                      }
                      return currentOptions
                        .filter((r) => selected.includes(r.value))
                        .map((r) => r.label)
                        .join(", ");
                    }}
                  >
                    <MenuItem disabled value="">
                      <span>{getRolePlaceholder()}</span>
                    </MenuItem>

                    {/* Select All */}
                    <MenuItem value="all" className="multi_check_select">
                      <Checkbox
                        checked={
                          formvalue.selectedRoles.length ===
                          currentOptions.length
                        }
                        indeterminate={
                          formvalue.selectedRoles.length > 0 &&
                          formvalue.selectedRoles.length < currentOptions.length
                        }
                      />
                      Select All
                    </MenuItem>

                    {/* Dynamic Role List */}
                    {currentOptions.map((role) => (
                      <MenuItem
                        key={role.value}
                        value={role.value}
                        className="multi_check_select"
                      >
                        <Checkbox
                          checked={formvalue.selectedRoles.includes(role.value)}
                        />
                        {role.label}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              )}
              {formvalue.selectField1 === "10" && (
                <>
                  <div className="control_group w_50">
                    <Select
                      fullWidth
                      value={selectedCategory}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                      displayEmpty
                    >
                      <MenuItem disabled value="">
                        Select Category
                      </MenuItem>
                      {categoryOptions.map((cat) => (
                        <MenuItem key={cat} value={cat}>
                          {cat}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>

                  <div className="control_group w_50">
                    <Autocomplete
                      disablePortal
                      options={offerOptions}
                      sx={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField placeholder="Select Offer Name" hiddenLabel {...params} />
                      )}
                    />
                    {/* <Select
                      fullWidth
                      value={selectedOffer}
                      onChange={(e) => setSelectedOffer(e.target.value)}
                      displayEmpty
                    >
                      <MenuItem disabled value="">
                        Select Offer Name
                      </MenuItem>
                      {offerOptions.map((offer) => (
                        <MenuItem key={offer} value={offer}>
                          {offer}
                        </MenuItem>
                      ))}
                    </Select> */}
                  </div>
                </>
              )}
              {/* Type Selector */}
              <div className="control_group w_50">
                <Select
                  fullWidth
                  name="type"
                  value={formvalue.type}
                  onChange={handleSingleSelectChange}
                >
                  <MenuItem disabled value="0">
                    Select Type
                  </MenuItem>
                  <MenuItem value="10">Broadcast</MenuItem>
                  <MenuItem value="20">Email</MenuItem>
                </Select>
              </div>

              {formvalue.type === "10" && (
                <div className="control_group">
                  <TextField
                    placeholder="Enter Note"
                    fullWidth
                    hiddenLabel
                    multiline
                    minRows={3}
                  />
                </div>
              )}

              {formvalue.type === "20" && (
                <div className="control_group w_100">
                  <EditText content={legal3} setContent={setLegal3} />
                </div>
              )}
            </div>

            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default AddNotification;
